import { render, staticRenderFns } from "./LawAuthorityCategoryForm.vue?vue&type=template&id=1d294b58&"
import script from "./LawAuthorityCategoryForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityCategoryForm.vue?vue&type=style&index=0&id=1d294b58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports